
import {
  computed,
  defineComponent,
  ref,
  onMounted,
} from 'vue';
import { useStore } from 'vuex';

export default defineComponent({
  props: {
    align: {
      type: String,
      required: false,
      default: () => 'center',
    },
  },

  setup(props, context) {
    const store = useStore();

    const textDeco = ref<InstanceType<typeof HTMLElement>>();
    const textDecoTop = ref<InstanceType<typeof HTMLElement>>();
    const textDecoBottom = ref<InstanceType<typeof HTMLElement>>();

    const showSelf = context.slots.default && context.slots.default().length;

    const pageType = computed<string>(() => store.getters['pages/pageType']);

    const {
      ioappConfig: {
        themeUri,
      },
    } = window;

    const setTextDecoration = () => {
      if (textDeco.value && textDecoTop.value && textDecoBottom.value) {
        textDeco.value.style.backgroundImage = `url('${themeUri}/assets/img/text_deco/common.svg')`;
        textDecoTop.value.style.backgroundImage = `url('${themeUri}/assets/img/text_deco/${pageType.value}_2.svg')`;
        textDecoBottom.value.style.backgroundImage = `url('${themeUri}/assets/img/text_deco/${pageType.value}_1.svg')`;
      }
    };

    onMounted(() => {
      setTextDecoration();
    });

    return {
      pageType,
      textDeco,
      textDecoTop,
      textDecoBottom,
      showSelf,
    };
  },
});
